import { PageRef } from 'providers/page-ref';

export enum EditMealScope {
  Meal = 'meal',
  Day = 'day'
}

export type EditMealPageParams = {
  id?: string;
  day?: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export const IEditMealPage: PageRef<EditMealPageParams, void> = {
  pageName: 'EditMealPage',
} as PageRef<EditMealPageParams, void>;
